import React from 'react';
import { Book, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import { bookData } from '../data/mock';
import { VisitCounter } from './VisitCounter';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-card border-t border-border-medium py-12">
      <div className="container mx-auto px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-3">
            <Book className="w-6 h-6 text-brand-primary" />
            <div>
              <p className="body-medium text-brand-primary font-semibold">Cronache dal fronte invisibile</p>
              <p className="caption text-text-secondary">di Saverio Santoniccolo</p>
            </div>
          </div>

          <div className="text-center md:text-right">
            <p className="body-small text-text-secondary mb-3">
              Per informazioni:
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 justify-center md:justify-end">
                <Mail className="w-4 h-4 text-brand-primary" />
                <a 
                  href={`mailto:${bookData.contact.email}`}
                  className="body-small text-brand-primary hover:underline"
                >
                  {bookData.contact.email}
                </a>
              </div>
              
              <div className="flex items-center gap-4 justify-center md:justify-end">
                <a 
                  href={`https://www.facebook.com/search/top?q=${encodeURIComponent(bookData.contact.social.facebook)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-secondary hover:text-brand-primary transition-colors"
                  title="Facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                
                <a 
                  href={`https://www.instagram.com/explore/search/keyword/?q=${encodeURIComponent(bookData.contact.social.instagram)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-secondary hover:text-brand-primary transition-colors"
                  title="Instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                
                <a 
                  href={`https://www.linkedin.com/search/results/people/?keywords=${encodeURIComponent(bookData.contact.social.linkedin)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-secondary hover:text-brand-primary transition-colors"
                  title="LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border-medium flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="caption text-text-secondary">
            © {currentYear} Saverio Santoniccolo. Tutti i diritti riservati.
          </p>
          <VisitCounter />
        </div>
      </div>
    </footer>
  );
};
